import React, { useState } from 'react';

function Settings() {
  const [regime, setRegime] = useState(localStorage.getItem('tax_regime') || 'УСН');

  const save = () => {
    localStorage.setItem('tax_regime', regime);
    alert('Сохранено!');
  };

  return (
    <div>
      <h2>Настройки</h2>
      <div style={{ marginTop: 12, display: 'flex', flexDirection: 'column', gap: 10, maxWidth: 400 }}>
        <label style={{ color: '#94A3B8', fontSize: 14 }}>Налоговый режим</label>
        <select value={regime} onChange={e => setRegime(e.target.value)} style={{ padding: 10, background: '#0F172A', border: '1px solid #334155', borderRadius: 8, color: '#F8FAFC', fontSize: 14 }}>
          <option>УСН</option>
          <option>ОСНО</option>
          <option>ПСН</option>
        </select>
        <button onClick={save} style={{ padding: '10px 20px', background: '#6366F1', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 600, marginTop: 8 }}>Сохранить</button>
      </div>
    </div>
  );
}

export default Settings;